export const PUBLICATION_FORM_ANNONCE_IMAGE_CONSTS = {
  cancelMsg: 'Отмена',
  changeMsg: 'Вставить фото',
  deleteMsg: 'Удалить',
  insertingImageMsg: 'Вставка фото',
  pasteMsg: 'Вставить фото',
  unknownMsg: 'Неизвестен'
}
